import React from 'react';
import cn from 'classnames';
import Title from 'components/UI/Title';
import Subtitle from 'components/UI/Subtitle';

import * as styles from './ModalAside.module.scss';

export default function EventAside({ className, data }) {
  const { title, subtitle } = data;

  return (
    <div className={cn(styles.wrapper, className)}>
      <Title tag="p" size="h3" color="white">
        {title}
      </Title>
      <Subtitle color="white">{subtitle}</Subtitle>
    </div>
  );
}
